import { Dispatch, SetStateAction, useCallback } from 'react'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { ScheduleType } from 'types/schedule'
import { StockUnionType } from 'types/stock'
import { getUpdateSchedulesFunction } from 'components/Templates/product/ProductEditTemplate'

const useSelectAllDaysOfWeek = (
  setDailySchedules: Dispatch<SetStateAction<ScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<ScheduleType[]>>
) => {
  return useCallback(
    (daysOfWeek: DayOfWeekType[], index: number, type: StockUnionType | '') => {
      const setState = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!setState) return
      setState((prevState) => {
        prevState[index].days_of_week = [...daysOfWeek]
        return [...prevState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useSelectAllDaysOfWeek
